/**
 * @file PrivacyView.jsx
 * @author Fernando Ruano
 * @description Privacy View Page
 */

// Dependencies
import AppCardLayout from 'components/AppCardLayout';
import React from 'react';

import { privacy } from '@nephro/commons/helpers/string-helper';

function PrivacyView() {
  return (
    <AppCardLayout>
      <div className="text-baxterGray py-4 px-5">
        <section>
          <td
            dangerouslySetInnerHTML={{
              __html: privacy
            }}
          />
        </section>
      </div>
    </AppCardLayout>
  );
}

export default PrivacyView;
